// src/components/CluesSection.jsx
import React, { useState, useEffect } from "react";

/**
 * CluesSection
 * ──────────────────────────────────────────────────────────────────────
 * Props:
 *   - visibleClues: array of unlocked clue strings.
 *
 * Shows one clue at a time. Dots at the bottom let you switch between unlocked clues.
 */
export default function CluesSection({ visibleClues }) {
  const [currentIndex, setCurrentIndex] = useState(0);

  // Whenever visibleClues changes, jump to the newest clue (last index).
  useEffect(() => {
    const lastIndex = visibleClues.length ? visibleClues.length - 1 : 0;
    setCurrentIndex(lastIndex);
  }, [visibleClues]);

  // If no clues yet, show an empty blank string so the layout stays consistent.
  const slides = visibleClues.length ? visibleClues : [""];

  return (
    <div className="clues-frame">
      {/* Clue text area */}
      <div className="clue-slide">
        <div className="clue-text">{slides[currentIndex]}</div>
      </div>

      {/* Dot indicators */}
      <div className="clue-dots">
        {slides.map((_, idx) => (
          <span
            key={idx}
            className={`dot ${idx === currentIndex ? "active" : ""}`}
            onClick={() => setCurrentIndex(idx)}
          />
        ))}
      </div>
    </div>
  );
}
